import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const DocusignBoarder = Loadable({
  loader: () => import("./components/docusignboarder"),
  loading: Loading,
});
const DocusignBoarderInterview = Loadable({
  loader: () => import("./components/docusignboarder_interview"),
  loading: Loading,
});

export const routes = [
  {
    path: "/docusignboarder",
    exact: true,
    name: "docusignboarder",
    component: DocusignBoarder,
  },
  {
    path: "/docusign_interview",
    exact: true,
    name: "docusign_interview",
    component: DocusignBoarderInterview,
  },
];
